export class Carrier {
    standardCarrierAlphaCode: string;
    name: string;

    constructor(options?: Partial<Carrier>) {
        Object.assign(this, options);
    }
}
